// @ts-nocheck
import { resolveBrowserCircuitPaths } from "./constants.js";

/** @type {Promise<{ wasm: string; zkey: string }> | null} */
let defaultCircuitPathsPromise = null;

/** @returns {Promise<{ wasm: string; zkey: string }>} */
export function loadDefaultCircuitPaths() {
  const browser = resolveBrowserCircuitPaths();
  if (browser) {
    return Promise.resolve(browser);
  }

  if (!defaultCircuitPathsPromise) {
    defaultCircuitPathsPromise = import(
      new URL("./circuits/paths.js", import.meta.url).href
    )
      .then((mod) => mod.resolveCircuitPaths())
      .catch((cause) => {
        throw new Error(
          "arcane-privacy-sdk: unable to resolve withdraw circuit paths. " +
            "Pass circuitWasmPath and circuitZkeyPath to generateWithdrawProof.",
          { cause }
        );
      });
  }

  return defaultCircuitPathsPromise;
}
